// @auto-index

import './styles.css'
import Button from './Button'

export { default as Button } from './Button'

export default Button
